import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import Checkbox from "@/components/CheckBox/Checkbox";
import { TABLE_NAMES } from "@/shared";
import RectangleLoader from "@/shared/components/loaders/RectangleLoader";
import SelectedRowsTag from "@/shared/components/tags/SelectedRowsTag";

import { colors } from "@dotnet/telematics-design-system";

import { ResourceCounts } from "./types/interfaces";

interface ExportResourceDialogContentProps {
  isLoading: boolean;
  resourceCounts: ResourceCounts | null;
  tableName: TABLE_NAMES;
  isIncludeChecked: boolean;
  setIsIncludeChecked: Dispatch<SetStateAction<boolean>>;
}

const ExportResourceDialogContent = ({
  isLoading,
  resourceCounts,
  tableName,
  isIncludeChecked,
  setIsIncludeChecked
}: ExportResourceDialogContentProps) => {
  const { t } = useTranslation();

  const tagTitle = t(`General##${tableName}`);

  const handleCheckbox = () => {
    setIsIncludeChecked(prev => !prev);
  };

  const currentCount = isIncludeChecked
    ? Number(resourceCounts?.allCompaniesCount)
    : Number(resourceCounts?.selectedCompanyCount);

  return (
    <>
      {!isLoading ? (
        <SelectedRowsTag
          tagTitle={tagTitle}
          resourceName={tableName}
          resourceCount={currentCount}
        />
      ) : (
        <RectangleLoader
          height={32}
          width={120}
          backgroundColor={colors.blue100}
        />
      )}

      <Checkbox
        id={`include-${tableName}-from-companies`}
        label={t(
          `Dialog##export ${tableName}##include ${tableName} from all companies`
        )}
        onChange={handleCheckbox}
        checked={isIncludeChecked}
        customStyle={{
          marginTop: "16px",
          display: "flex"
        }}
      />
    </>
  );
};

export default ExportResourceDialogContent;
